import { CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsModule } from '../reports/reports.module';
import { RouterWrapperAppComponent } from './components/app/app.component';
import { DashboardPageComponent } from './components/dashboard-page/dashboard-page.component';
import { RouterModule, Routes } from '@angular/router';
import { AccountPageComponent } from './components/account-page/account-page.component';
import { CampaignsPageComponent } from './components/campaigns-page/campaigns-page.component';
import { ManagePageComponent } from './components/manage-page/manage-page.component';
import { LegalPageComponent } from './components/legal-page/legal-page.component';
import { EventsPageComponent } from './components/events-page/events-page.component';
import { LiveStreamingPageComponent } from './components/live-streaming-page/live-streaming-page.component';
import { ReportTransfersPageComponent } from './components/report-transfers-page/report-transfers-page.component';
import { AllDonationsPageComponent } from './components/all-donations-page/all-donations-page.component';
import { AllPendingReportCartsPageComponent } from './components/all-pending-report-carts-page/all-pending-report-carts-page.component';
import { RecurringPageComponent } from './components/recurring-page/recurring-page.component';
import { MenuUnsettledPageComponent } from './components/menu-unsettled-page/menu-unsettled-page.component';
import { MenuMatchingPageComponent } from './components/menu-matching-page/menu-matching-page.component';
import { MenuOfflineOnePageComponent } from './components/menu-offline-one-page/menu-offline-one-page.component';
import { MenuOfflineBulkPageComponent } from './components/menu-offline-bulk-page/menu-offline-bulk-page.component';
import { CapmaignReportPageComponent } from './components/capmaign-report-page/capmaign-report-page.component';
import { DonorsReportPageComponent } from './components/donors-report-page/donors-report-page.component';
import { CampaignPaidReportPageComponent } from './components/campaign-paid-report-page/campaign-paid-report-page.component';
import { LinkComponent } from './components/link/link.component';
import { createCustomElement } from '@angular/elements';
import { CampaignPendingReportPageComponent } from './components/campaign-pending-report-page/campaign-pending-report-page.component';
import { TicketGuestListPageComponent } from './components/ticket-guest-list-page/ticket-guest-list-page.component';
import { TicketBasketRaffleAllocationListPageComponent } from './components/ticket-basket-raffle-allocation-list-page/ticket-basket-raffle-allocation-list-page.component';
import { VirtualEventAtendeePageComponent } from './components/virtual-event-atendee-page/virtual-event-atendee-page.component';
import { InPersonEventAttendeesPageComponent } from './components/in-person-event-attendees-page/in-person-event-attendees-page.component';
import { CoreModule } from '../core/core.module';
import { IconModule } from '../icon/icon.module';
import { DialogModule } from '../dialog/dialog.module';
import { ToastModule } from '../toast/toast.module';
import { CounterModule } from '../core/modules/counter/counter.module'
import { MdbDropdownModule } from 'mdb-angular-ui-kit/dropdown';
import { MdbPopoverModule } from 'mdb-angular-ui-kit/popover';
import { LetModule, PushModule } from '@ngrx/component';
import { MdbAccordionModule } from 'mdb-angular-ui-kit/accordion';
import { SilentAuctionSlideShowModule } from '../silent-auction-slide-show/silent-auction-slide-show.module';

import { AuthGuard } from './guards/auth.guard';
import { LoginComponent } from './modals/login/login/login.component';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EmptyPageComponent } from './components/empty-page/empty-page.component';
import { JquerySelectControlComponent } from './components/jquery-select-control/jquery-select-control.component';
import { DemoGuard } from './guards/demo.guard';
import { RedirectGuard } from './guards/redirect.guard';
import { CampaignModule } from '../campaign/campaign.module';
import { EventModule } from '../event/event.module';
import { DashboardModule } from '../dashboard/dashboard.module';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { MdbAutocompleteModule } from 'mdb-angular-ui-kit/autocomplete';
import { TicketingAndGuestsModule } from '../ticketing-and-guests/ticketing-and-guests.module';
import { ManageSeatListPageComponent } from './components/manage-seat-list-page/manage-seat-list-page.component';
import { MdbTabsModule } from 'mdb-angular-ui-kit/tabs';
import { ManageP2pModule } from 'app/manage-p2p/manage-p2p.module';
import { ManageAuctionsModule } from '../manage-auctions/manage-auctions.module';
import { ManageAuctionsPageComponent } from 'app/manage-auctions/components/manage-auctions-page/manage-auctions-page.component';
import { ManageAutionPageAComponent } from 'app/manage-auctions/components/manage-aution-page-a/manage-aution-page-a.component';
import { ManagePeerToPeerPageComponent } from '../manage-p2p/components/manage-peer-to-peer-page/manage-peer-to-peer-page.component';
import { ManagePeerToPeerDetailsPageComponent } from 'app/manage-p2p/components/manage-peer-to-peer-details-page/manage-peer-to-peer-details-page.component';
import { AccountComponent } from 'app/account/components/account/account.component';
import { UsersModule } from 'app/users/users.module';
import { UsersPageComponent } from './components/users-page/users-page.component';
import { VolunteersModule } from 'app/volunteers/volunteers.module';
import { VolunteersPageComponent } from './components/volunteers-page/volunteers-page.component';
import { SwitchOrganizationComponent } from './modals/switch-organization/switch-organization.component';
import { IntegrationMonkeyPageComponent } from './components/integration-monkey-page/integration-monkey-page.component';
import { IntegrationMonkeyModule } from 'app/integrations/monkey/integration-monkey.module';
import { ManageWebhookDetailsComponent } from 'app/integrations/monkey/components/manage-webhook-details/manage-webhook-details.component';
import { MerchandiseReportPageComponent } from './components/merchandise-report-page/merchandise-report-page.component';
import { MerchandiseDetailsComponent } from 'app/manage-merchandise/components/merchandise-details/merchandise-details.component';
import { PartySignupReportPageComponent } from './components/party-signup-report-page/party-signup-report-page.component';
import { PartySignupDetailsComponent } from 'app/manage-party-signup/components/party-signup-details/party-signup-details.component';
import { TicketingReportPageComponent } from './components/ticketing-report-page/ticketing-report-page.component';
import { TicketsAndGuestsDetailsComponent } from 'app/manage-tickets-and-guests/components/tickets-and-guests-details/tickets-and-guests-details.component';
import { CampaignListComponent } from 'app/campaign/components/campaign-list/campaign-list.component';
import { CampaignTypeComponent } from 'app/campaign/components/campaign-type/campaign-type.component';
import { CampaignDonationComponent } from 'app/campaign/components/campaign-donation/campaign-donation.component';
import { CampaignMerchandiseComponent } from 'app/campaign/components/campaign-merchandise/campaign-merchandise.component';
import { CampaignHinduTemplePujaComponent } from 'app/campaign/components/campaign-hindu-temple-puja/campaign-hindu-temple-puja.component';
import { CampaignAuctionComponent } from 'app/campaign/components/campaign-auction/campaign-auction.component';
import { CampaignPartySignUpComponent } from 'app/campaign/components/campaign-party-signup/campaign-party-signup.component';
import { CampaignTicketingComponent } from 'app/campaign/components/campaign-ticketing/campaign-ticketing.component';
import { CampaignLongPledgeComponent } from 'app/campaign/components/campaign-long-pledge/campaign-long-pledge.component';
import { CampaignPeerToPeerFundraisingComponent } from 'app/campaign/components/campaign-peer-to-peer-fundraising/campaign-peer-to-peer-fundraising.component';
import { CampaignLastHeroComponent } from 'app/campaign/components/campaign-last-hero/campaign-last-hero.component';
import { CampaignInKindComponent } from 'app/campaign/components/campaign-in-kind/campaign-in-kind.component';
import { EventListComponent } from 'app/event/components/event-list/event-list.component';
import { EventTypeComponent } from 'app/event/components/event-type/event-type.component';
import { InPersonEventComponent } from 'app/event/components/in-person-event/in-person-event.component';
import { VirtualEventComponent } from 'app/event/components/virtual-event/virtual-event.component';
import { HybridEventComponent } from 'app/event/components/hybrid-event/hybrid-event.component';
import { VirtualEventRunComponent } from 'app/virtual-event/components/virtual-event/virtual-event.component';

const routes: Routes = [{
  path: 'dashboard',
  component: DashboardPageComponent,
  canActivate: [DemoGuard, AuthGuard],
  canDeactivate: [AuthGuard],
  runGuardsAndResolvers:'always'
},
{
  path: 'account',
  component: AccountPageComponent,
  canActivate: [DemoGuard, AuthGuard],
  canDeactivate: [AuthGuard],
  runGuardsAndResolvers:'always'
},
{
  path: 'campaign',
  pathMatch: 'full',
  redirectTo: 'campaign/list'
},
{
  path: 'campaign',
  component: CampaignsPageComponent,
  canActivate: [DemoGuard, AuthGuard],
  canDeactivate: [AuthGuard],
  children: [
    {
      path: 'list',
      component: CampaignListComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'select-type',
      component: CampaignTypeComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'donation',
      component: CampaignDonationComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'donation/:id',
      component: CampaignDonationComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'merchandise',
      component: CampaignMerchandiseComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'merchandise/:id',
      component: CampaignMerchandiseComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'hindu-temple-puja',
      component: CampaignHinduTemplePujaComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'hindu-temple-puja/:id',
      component: CampaignHinduTemplePujaComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'auction',
      component: CampaignAuctionComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'auction/:id',
      component: CampaignAuctionComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'party-signup',
      component: CampaignPartySignUpComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'party-signup/:id',
      component: CampaignPartySignUpComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'ticketing',
      component: CampaignTicketingComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'ticketing/:id',
      component: CampaignTicketingComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'long-pledge',
      component: CampaignLongPledgeComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'long-pledge/:id',
      component: CampaignLongPledgeComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'peer-to-peer-fundraising',
      component: CampaignPeerToPeerFundraisingComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'peer-to-peer-fundraising/:id',
      component: CampaignPeerToPeerFundraisingComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'last-hero',
      component: CampaignLastHeroComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'last-hero/:id',
      component: CampaignLastHeroComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'in-kind',
      component: CampaignInKindComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'in-kind/:id',
      component: CampaignInKindComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    }
  ]
},
/*
{
  path: 'events',
  component: EventsPageComponent,
  canActivate: [DemoGuard, AuthGuard],
  canDeactivate: [AuthGuard],
  runGuardsAndResolvers:'always'
},
*/
{
  path: 'event',
  pathMatch: 'full',
  redirectTo: 'event/list'
},
{
  path: 'event',
  component: EventsPageComponent,
  canActivate: [DemoGuard, AuthGuard],
  canDeactivate: [AuthGuard],
  children: [
    {
      path: 'list',
      component: EventListComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'select-type',
      component: EventTypeComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'in-person',
      component: InPersonEventComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'in-person/:id',
      component: InPersonEventComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'in-person/:id/report',
      component: InPersonEventAttendeesPageComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'virtual',
      component: VirtualEventComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'virtual/:id',
      component: VirtualEventComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'virtual/:id/run',
      component: VirtualEventRunComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'virtual/:id/report',
      component: VirtualEventAtendeePageComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'hybrid',
      component: HybridEventComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'hybrid/:id',
      component: HybridEventComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    }
  ]
},
{
  path: 'manage/tickets-and-guests',
  pathMatch: 'full',
  redirectTo: 'manage/tickets-and-guests/list', 
},
{
  path: 'manage/tickets-and-guests',
  canActivate: [DemoGuard, AuthGuard],
  canDeactivate: [AuthGuard],
  children: [
    {
      path: 'list',
      component: TicketingReportPageComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'campaign/:campaignId/table/:id/seat/list',
      component: ManageSeatListPageComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'campaign/:id',
      component: TicketsAndGuestsDetailsComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard]
    },
    {
      path: 'ticket/:id/guest/list',
      component: TicketGuestListPageComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'ticket/:id/basket-raffle/allocation/list',
      component: TicketBasketRaffleAllocationListPageComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    }
  ]
},

{
  path: 'manage/p2p',
  pathMatch: 'full',
  redirectTo: 'manage/p2p/list'
},
{
  path: 'manage/p2p/list',
  canActivate: [DemoGuard, AuthGuard],
  canDeactivate: [AuthGuard],
  component: ManagePeerToPeerPageComponent
},
{
  path: 'manage/p2p/:id',
  component: ManagePeerToPeerDetailsPageComponent,
  canActivate: [DemoGuard, AuthGuard],
  canDeactivate: [AuthGuard]
},
{
  path: 'streaming',
  component: LiveStreamingPageComponent,
  canActivate: [DemoGuard, AuthGuard],
  canDeactivate: [AuthGuard],
  runGuardsAndResolvers:'always'
},
{
  path: 'integration/web-hook',
  pathMatch: 'full',
  redirectTo: 'integration/web-hook/list', 
},
{
  path: 'integration/web-hook',
  children: [
    {
      path: 'list',
      component: IntegrationMonkeyPageComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: ':id',
      component: ManageWebhookDetailsComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
  ]
},
{
  path: 'reportTransfers',
  component: ReportTransfersPageComponent,
  canActivate: [DemoGuard, AuthGuard],
  runGuardsAndResolvers:'always'
},
{
  path: 'reportAll',
  component: AllDonationsPageComponent,
  canActivate: [DemoGuard, AuthGuard],
  canDeactivate: [AuthGuard],
  runGuardsAndResolvers:'always'
},
// {
//   path: 'reportPending',
//   component: AllPendingReportPageComponent,
//   canActivate: [DemoGuard, AuthGuard],
//   runGuardsAndResolvers:'always'
// },
{
  path: 'reportPendingCarts',
  component: AllPendingReportCartsPageComponent,
  canActivate: [DemoGuard, AuthGuard],
  canDeactivate: [AuthGuard],
  runGuardsAndResolvers:'always'
},
{
  path: 'reports/campaign',
  pathMatch: 'full',
  redirectTo: 'reports/campaign/list', 
},
{
  path: 'reports/campaign',
  children: [
    {
      path: 'list',
      component: CapmaignReportPageComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'paid/:type/:id',
      component: CampaignPaidReportPageComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: 'pending/:type/:id',
      component: CampaignPendingReportPageComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
  ]
},
{
  path: 'reportDonors',
  component: DonorsReportPageComponent,
  canActivate: [DemoGuard, AuthGuard],
  canDeactivate: [AuthGuard],
  runGuardsAndResolvers:'always'
},
{
  path: 'reportRecurring',
  component: RecurringPageComponent,
  canActivate: [DemoGuard, AuthGuard],
  canDeactivate: [AuthGuard],
  runGuardsAndResolvers:'always'
},
{
  path: 'manage/merchandise',
  runGuardsAndResolvers:'always',
  redirectTo: 'manage/merchandise/list' 
},
{
  path: 'manage/merchandise',
  canActivate: [DemoGuard, AuthGuard],
  canDeactivate: [AuthGuard],
  children: [
    {
      path: 'list',
      component: MerchandiseReportPageComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: ':id',
      component: MerchandiseDetailsComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard]
    },
  ]
},
{
  path: 'manage/party-signup',
  runGuardsAndResolvers:'always',
  redirectTo:'manage/party-signup/list'
},
{
  path: 'manage/party-signup',
  canActivate: [DemoGuard, AuthGuard],
  canDeactivate: [AuthGuard],
  children: [
    {
      path: 'list',
      component: PartySignupReportPageComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard],
      runGuardsAndResolvers:'always'
    },
    {
      path: ':id',
      component: PartySignupDetailsComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard]
    },
  ]
},
{
  path: 'reportUnsettled',
  component: MenuUnsettledPageComponent,
  canActivate: [AuthGuard],
  canDeactivate: [AuthGuard],
  runGuardsAndResolvers:'always'
},
{
  path: 'reportMatching',
  component: MenuMatchingPageComponent,
  canActivate: [DemoGuard, AuthGuard],
  canDeactivate: [AuthGuard],
  runGuardsAndResolvers:'always'
},
{
  path: 'volunteers',
  component: VolunteersPageComponent,
  canActivate: [DemoGuard, AuthGuard],
  canDeactivate: [AuthGuard],
  runGuardsAndResolvers:'always'
},
{
  path: 'offlineOne',
  component: MenuOfflineOnePageComponent,
  canActivate: [DemoGuard, AuthGuard],
  canDeactivate: [AuthGuard],
  runGuardsAndResolvers:'always'
},
{
  path: 'offlineBulk',
  component: MenuOfflineBulkPageComponent,
  canActivate: [DemoGuard, AuthGuard],
  canDeactivate: [AuthGuard],
  runGuardsAndResolvers:'always'
},
{
  path: 'users',
  component: UsersPageComponent,
  canActivate: [DemoGuard, AuthGuard],
  canDeactivate: [AuthGuard],
  runGuardsAndResolvers:'always'
},
{
  path: 'legal',
  component: LegalPageComponent,
  canActivate: [DemoGuard, AuthGuard],
  canDeactivate: [AuthGuard],
  runGuardsAndResolvers:'always'
}, {
  path: 'empty-page',
  component: EmptyPageComponent,
  canActivate: [DemoGuard],
  canDeactivate: [AuthGuard],
  runGuardsAndResolvers:'always'
}, {
  path: 'manageAuction',
  pathMatch: 'full',
  redirectTo: 'manageAuction/list'
}, {
  path: 'manageAuction',
  canActivate: [DemoGuard, AuthGuard],
  canDeactivate: [AuthGuard],
  children: [
    { path: 'list',
      component: ManageAuctionsPageComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard]
    },
    {
      path: ':id',
      component: ManageAutionPageAComponent,
      canActivate: [DemoGuard, AuthGuard],
      canDeactivate: [AuthGuard]
    }
  ]
}, {
  path: '',
  pathMatch: 'full',
  component: EmptyPageComponent,
  canActivate: [RedirectGuard],
  canDeactivate: [AuthGuard]
}, {
  path: 'org.html',
  pathMatch: 'full',
  component: EmptyPageComponent,
  canActivate: [RedirectGuard],
  canDeactivate: [AuthGuard]
}];

@NgModule({
  declarations: [
    RouterWrapperAppComponent,
    DashboardPageComponent,
    AccountPageComponent,
    CampaignsPageComponent,
    VolunteersPageComponent,
    ManagePageComponent,
    LegalPageComponent,
    EventsPageComponent,
    LiveStreamingPageComponent,
    IntegrationMonkeyPageComponent,
    ReportTransfersPageComponent,
    AllDonationsPageComponent,
    // AllPendingReportPageComponent,
    AllPendingReportCartsPageComponent,
    RecurringPageComponent,
    MenuUnsettledPageComponent,
    MenuMatchingPageComponent,
    MenuOfflineOnePageComponent,
    MenuOfflineBulkPageComponent,
    CapmaignReportPageComponent,
    DonorsReportPageComponent,
    CampaignPaidReportPageComponent,
    LinkComponent,
    CampaignPendingReportPageComponent,
    TicketGuestListPageComponent,
    TicketBasketRaffleAllocationListPageComponent,
    VirtualEventAtendeePageComponent,
    InPersonEventAttendeesPageComponent,
    EmptyPageComponent,
    LoginComponent,
    SwitchOrganizationComponent,
    JquerySelectControlComponent,
    ManageSeatListPageComponent,
    UsersPageComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MdbFormsModule,
    ReportsModule,
    RouterModule.forRoot(routes, { bindToComponentInputs: true, useHash: false, onSameUrlNavigation: "reload" }),
    CoreModule,
    DialogModule,
    ToastModule,
    DashboardModule,
    CampaignModule,
    EventModule,
    ReportsModule,
    UsersModule,
    IntegrationMonkeyModule,
    IconModule,
    MdbDropdownModule,
    MdbPopoverModule,
    CounterModule,
    MdbSelectModule,
    MdbAutocompleteModule,
    ManageP2pModule,
    LetModule,
    PushModule,
    MdbAccordionModule,
    TicketingAndGuestsModule,
    MdbTabsModule,
    SilentAuctionSlideShowModule,
    ManageAuctionsModule,
    ManagePeerToPeerPageComponent,
    ManagePeerToPeerDetailsPageComponent,
    AccountComponent,
    VolunteersModule
  ],
  exports: [
    RouterWrapperAppComponent,
    RouterModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class RouterWrapperModule {
  constructor(injector: Injector) {
    const LinkElement = createCustomElement(LinkComponent, {injector});

    try {
      customElements.define('paybee-app-link', LinkElement);
    } catch(e) {}
  }
}
